import axios from "../../apiFc24";
import { SavedOrSharedSquadResponseData } from "./get-saved-squad";

export const getSharedSquad = async (id: string) => {
  const res = await axios.get<SavedOrSharedSquadResponseData>(
    "/shared-squads/" + id,
  );
  return res.data;
};
